import { Stack } from '@chakra-ui/react'
import React, { useState } from 'react'

import countCharacters from '@/client/services/richText/countCharacters'
import isSerializedRichTextProbably from '@/client/services/richText/isSerializedRichTextProbably'
import type { SerializedRichText } from '@/client/services/richText/types'

import RichTextEditorAdvanced from '@/components/UI/RichTextEditor/RichTextEditorAdvanced'
import RichTextEditorSimple from '@/components/UI/RichTextEditor/RichTextEditorSimple/RichTextEditorSimple'

import { FormContext, type FormInputType } from '../types'
import CharacterCount from './internal/CharacterCount'

const FormInputRichText: React.FC<{
  input: FormInputType & { type: 'rich-text' }
}> = ({ input }) => {
  const { name: inputName, editorType = 'simple', height, maxHeight } = input
  const { submitting, onChange } = React.useContext(FormContext)
  const [length, setLength] = useState(
    isSerializedRichTextProbably(input.initialValue)
      ? countCharacters(input.initialValue)
      : (input.initialValue?.length ?? 0)
  )

  const handleInput = React.useCallback(
    (value: SerializedRichText) => {
      onChange(inputName, value)
      setLength(countCharacters(value))
    },
    [inputName, onChange]
  )

  return (
    <Stack>
      {editorType === 'simple' ? (
        <RichTextEditorSimple
          name={input.name}
          placeholder={input.placeholder ?? ''}
          initialValue={input.initialValue ?? ''}
          disabled={submitting || input.disabled}
          onChange={handleInput}
          height={height}
          maxHeight={maxHeight}
          hideImageUpload
        />
      ) : (
        <RichTextEditorAdvanced
          name={input.name}
          placeholder={input.placeholder ?? ''}
          initialValue={input.initialValue ?? ''}
          disabled={submitting || input.disabled}
          height={height}
          maxHeight={maxHeight}
          onChange={handleInput}
        />
      )}
      {input.minLength != null || input.maxLength != null ? (
        <CharacterCount min={input.minLength} max={input.maxLength} length={length} />
      ) : null}
    </Stack>
  )
}

export default FormInputRichText
